import { Injectable } from '@angular/core';
import { Rpfi26Row, Rpfi26TableResult, Rpfi26Totals } from '../../models/report/rpfi26.model';

@Injectable({ providedIn: 'root' })
export class MapperRpfi26Service {
  mapTable(res: unknown): Rpfi26TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const rows = (raw['rows'] ?? raw['Rows'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      vehicleTypeId: (raw['vehicleTypeId'] ?? raw['VehicleTypeId'] ?? null) as number | null,
      vehicleTypeName: String(raw['vehicleTypeName'] ?? raw['VehicleTypeName'] ?? ''),
      rows: rows.map((r) => this.mapRow(r)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapRow(dto: unknown): Rpfi26Row {
    const r = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(r['seq'] ?? r['Seq'] ?? 0),
      receiptId: String(r['receiptId'] ?? r['ReceiptId'] ?? ''),
      entryLicense: String(r['entryLicense'] ?? r['EntryLicense'] ?? ''),
      entryDate: (r['entryDate'] ?? r['EntryDate'] ?? null) as string | null,
      paidDate: (r['paidDate'] ?? r['PaidDate'] ?? null) as string | null,
      manualExit: Number(r['manualExit'] ?? r['ManualExit'] ?? 0),
      cash: Number(r['cash'] ?? r['Cash'] ?? 0),
      qr: Number(r['qr'] ?? r['Qr'] ?? 0),
      durationText: String(r['durationText'] ?? r['DurationText'] ?? ''),
      fee: Number(r['fee'] ?? r['Fee'] ?? 0),
      vat: Number(r['vat'] ?? r['Vat'] ?? 0),
      total: Number(r['total'] ?? r['Total'] ?? 0),
    };
  }

  private mapTotals(dto: unknown): Rpfi26Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      rowCount: Number(t['rowCount'] ?? t['RowCount'] ?? 0),
      sumManualExit: Number(t['sumManualExit'] ?? t['SumManualExit'] ?? 0),
      sumCash: Number(t['sumCash'] ?? t['SumCash'] ?? 0),
      sumQr: Number(t['sumQr'] ?? t['SumQr'] ?? 0),
      sumFee: Number(t['sumFee'] ?? t['SumFee'] ?? 0),
      sumVat: Number(t['sumVat'] ?? t['SumVat'] ?? 0),
      sumTotal: Number(t['sumTotal'] ?? t['SumTotal'] ?? 0),
    };
  }
}
